// OTOMATİK ÜRETİLDİ — elle düzenlemeyin. Kaynak: scripts/gen-version.js (npm prebuild/prestart).
export const APP_VERSION = "20260810";
